import loadable from '@loadable/component';

export const partner_public = loadable(() => import('./PartnerPublicPage'));
export const partner_register = loadable(() => import('./PartnerRegisterPage'));
export const partner_registration = loadable(() => import('./PartnerRegistrationPage'));
export const partner_register_website = loadable(() => import('./PartnerRegisterWebsitePage'));
export const partner_registration_organization = loadable(() => import('./PartnerRegistrationOrganizationPage'));
export const partner_registration_owner = loadable(() => import('./PartnerRegistrationOwnerPage'));
export const partner_registration_game = loadable(() => import('./PartnerRegistrationGamePage'));
export const partner_registration_summary = loadable(() => import('./PartnerRegistrationSummaryPage'));